import styled from 'styled-components';
import MuiDrawer from '@material-ui/core/Drawer';

export const Drawer = styled(MuiDrawer)`
  .MuiDrawer-paper {
    background-color: transparent;
  }
`;
